import Header from '../../Header';
import './Canceled.css';

function Canceled(){

    return(
        <>
        <div class="cropCutter">
        <Header/>
        <section  id="mainBackground" class="hero is-fullheight">
            <div id="layer" class="hero-body">
            <div class="center">
            <div>
            <p id="sm" class="title" > An error has occured please try again or change payment mode.<br/>
            If the issue persists contact the admin on IG @naturalseducer. </p>
            
            </div>
            
            </div>
            </div>
        </section>
        </div> 
        </>
    );
}

export default Canceled;